define('LimitItemQuantity', [
  'LimitItemQuantity.Helper',
  'jQuery',
  'Cart.Detailed.View.LimitQty',
  'QuickOrder.View.LimitQty',
  'QuickAdd.View.LimitQty'
], function LimitItemQuantity(
  Helper,
  jQuery
) {
  'use strict';

  var cartLines;

  return {

    getCartLines: function getCartLines(cartComponent) {
      cartComponent.getLines().then(function getLines(lines) {
        cartLines = lines;
      });
    },

    mountToApp: function mountToApp(container) {
      var cartComponent = container.getComponent('Cart');
      var pdpComponent = container.getComponent('PDP');
      var environment = container.getComponent('Environment');
      var enableForPDP = environment.getConfig('limitItemQuantity.enabledForPDP');
      var self = this;
      var errorInsufficientAmount = Helper.insufficientAmount;
      this.getCartLines(cartComponent);
      if (enableForPDP) {
        cartComponent.cancelableOn('beforeAddLine', function beforeAddLine(itemToAdd) {
          var promise = jQuery.Deferred();
          var itemInfo = pdpComponent.getItemInfo();
          var errorMessage;
          var validateResult;
          if (!itemInfo) {
            promise.resolve();
          } else {
            validateResult = Helper.validateItem(itemInfo.item, itemToAdd.line.quantity, cartLines, pdpComponent);
            if (!validateResult.isValid) {
              errorMessage = errorInsufficientAmount.errorMessage.replace('[QTY]', validateResult.quantityAvailable);
              promise = Helper.errorResponse(errorMessage);
            } else {
              promise.resolve();
            }
          }
          return promise;
        });

        cartComponent.on('afterAddLine', function afterAddLine() {
          self.getCartLines(cartComponent);
        });

        cartComponent.on('afterUpdateLine', function afterAddLine() {
          self.getCartLines(cartComponent);
        });

        cartComponent.on('afterRemoveLine', function afterRemoveLine() {
          self.getCartLines(cartComponent);
        });
      }
    }
  };
});
